// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WXQX","colBig":"styles_colBig__1BfSD","colSmall":"styles_colSmall__2s_Lc"};